'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _withTypography = require('./with-typography');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withTypography).default;
  }
});

require('./with-typography.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }